/* import __COLOCATED_TEMPLATE__ from './hero-unit.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './hero-unit.module.scss';

@classic
@classNames(styles.component)
export default class SharedHeroUnit extends Component {
  @service currentPractice;
  @service localeManager;
}
